import React, {useEffect, useState} from "react";
import I18n from 'i18n.js.erb'
import {isDefined} from "../../utils/utils";

const AddressForm = ({
    shipmentAddress,
    updateShipmentAddressParams,
    countries,
    canUpdate,
    addressType,
    formSubmitted,
    hideEmail,
    resource
  }) => {

  const [ provinces, setProvinces ] = useState([]);

  // console.log('countries: ', countries);
  // console.log('shipmentAddress: ', shipmentAddress);

  useEffect(() => {
    if (isDefined(countries) && isDefined(shipmentAddress?.country_id) && isDefined(countries[shipmentAddress.country_id]) && isDefined(countries[shipmentAddress.country_id]['provinces'])) {
      setProvinces(countries[shipmentAddress.country_id]['provinces']);
      if (isDefined(shipmentAddress?.province) && !countries[shipmentAddress.country_id]['provinces'].includes(shipmentAddress.province))
        updateShipmentAddressParams(['province'], ['']);
    }
    else {
      setProvinces([]);
      updateShipmentAddressParams(['province'], ['']);
    }
  }, [shipmentAddress.country_id]);

  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return (
    <React.Fragment>
      <div className="w-100">
        <div className="row">
          <div className="col-12 col-md-6">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.firstName')}<sup>*</sup></p>
            <input
              type="text"
              disabled={!canUpdate}
              className={`form-control mb-2 ${(formSubmitted && shipmentAddress.first_name?.trim()?.length < 2) && 'border-aiG-red-imp'} address-input-form`}
              value={shipmentAddress.first_name || ''}
              name={resource ? resource + '[first_name]' : 'first_name'}
              id={resource ? resource.replaceAll('[', '_').replaceAll(']', '_') + 'first_name' : 'first_name'}
              placeholder={I18n.t('js.newUserAddressForm.firstNamePlaceholder')}
              onChange={(e) => updateShipmentAddressParams(['first_name'], [e.target.value])}
            />
          </div>

          <div className="col-12 col-md-6">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.lastName')}<sup>*</sup></p>
            <input
              type="text"
              disabled={!canUpdate}
              className={`form-control mb-2 ${(formSubmitted && addressType === 'user' && shipmentAddress.last_name?.trim()?.length < 2) && 'border-aiG-red-imp'} address-input-form`}
              value={shipmentAddress.last_name || ''}
              name={resource ? resource + '[last_name]' : 'last_name'}
              id={resource ? resource.replaceAll('[', '_').replaceAll(']', '_') + 'last_name' : 'last_name'}
              placeholder={I18n.t('js.newUserAddressForm.lastNamePlaceholder')}
              onChange={(e) => updateShipmentAddressParams(['last_name'], [e.target.value])}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.co')}</p>
            <input
              type="text"
              disabled={!canUpdate}
              className="form-control mb-2 address-input-form"
              value={shipmentAddress.co ? shipmentAddress.co : ''}
              name={resource ? resource + '[co]' : 'co'}
              id={resource ? resource.replaceAll('[', '_').replaceAll(']', '_') + 'co' : 'co'}
              placeholder={I18n.t('js.newUserAddressForm.coPlaceholder')}
              onChange={(e) => updateShipmentAddressParams(['co'], [e.target.value])}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-6">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.country')}<sup>*</sup></p>
            <select
              className={`form-control mb-2 ${(formSubmitted && !isDefined(shipmentAddress.country_id)) && 'border-aiG-red-imp'} address-input-form`}
              disabled={!canUpdate}
              value={shipmentAddress.country_id ? shipmentAddress.country_id : ''}
              name={resource ? resource + '[country_id]' : 'country_id'}
              id={resource ? resource.replaceAll('[', '_').replaceAll(']', '_') + 'country_id' : 'country_id'}
              onChange={(e) => {
                updateShipmentAddressParams(['country_id', 'country'], [e.target.value, isDefined(e.target.value) ? countries[e.target.value].name : '']);
              }}>
              <option id="empty_country" value="">
                {I18n.t('js.newUserAddressForm.countryPlaceholder')}
              </option>
              {
                Object.entries(countries)
                  .sort(([countryId1, countryData1], [countryId2, countryData2]) => countryData1.name < countryData2.name ? -1 : 0)
                  .map(([countryId, countryData]) => {
                    return <option id={countryId} value={countryId} key={countryId}>
                      {countryData.name}
                    </option>
                })
              }
            </select>
          </div>

          <div className="col-12 col-md-6">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.province')}<sup>*</sup></p>
            <select
              className={`form-control mb-2 ${(formSubmitted && shipmentAddress.province?.trim()?.length < 2) && 'border-aiG-red-imp'} address-input-form`}
              disabled={!canUpdate}
              value={shipmentAddress.province || ''}
              name={resource ? resource + '[province]' : 'province'}
              id={resource ? resource.replaceAll('[', '_').replaceAll(']', '_') + 'province' : 'province'}
              onChange={(e) => updateShipmentAddressParams(['province'], [e.target.value])}>
              <option id="empty_province" value="">
                {I18n.t('js.newUserAddressForm.provincePlaceholder')}
              </option>
              {
                provinces.map((province) => {
                  return <option id={province} value={province} key={province}>
                    {province}
                  </option>
                })
              }
            </select>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-6">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.city')}<sup>*</sup></p>
            <input
              type="text"
              disabled={!canUpdate}
              className={`form-control mb-2 ${(formSubmitted && shipmentAddress.city?.trim()?.length < 3) && 'border-aiG-red-imp'} address-input-form`}
              value={shipmentAddress.city || ''}
              name={resource ? resource + '[city]' : 'city'}
              id={resource ? resource.replaceAll('[', '_').replaceAll(']', '_') + 'city' : 'city'}
              placeholder={I18n.t('js.newUserAddressForm.cityPlaceholder')}
              onChange={(e) => updateShipmentAddressParams(['city'], [e.target.value])}
            />
          </div>

          <div className="col-12 col-md-6">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.postalCode')}<sup>*</sup></p>
            <input
              type="text"
              disabled={!canUpdate}
              className={`form-control mb-2 ${(formSubmitted && shipmentAddress.cap?.trim()?.length < 1) && 'border-aiG-red-imp'} hide-arrows-number address-input-form`}
              value={shipmentAddress.cap || ''}
              name={resource ? resource + '[cap]' : 'cap'}
              id={resource ? resource.replaceAll('[', '_').replaceAll(']', '_') + 'cap' : 'cap'}
              placeholder={I18n.t('js.newUserAddressForm.postalCodePlaceholder')}
              onChange={(e) => updateShipmentAddressParams(['cap'], [e.target.value])}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-6">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.street')}<sup>*</sup></p>
            <input
              type="text"
              disabled={!canUpdate}
              className={`form-control mb-2 ${(formSubmitted && shipmentAddress.street_square?.trim()?.length < 3) && 'border-aiG-red-imp'} address-input-form`}
              value={shipmentAddress.street_square || ''}
              name={resource ? resource + '[street_square]' : 'street_square'}
              id={resource ? resource.replaceAll('[', '_').replaceAll(']', '_') + 'street_square' : 'street_square'}
              placeholder={I18n.t('js.newUserAddressForm.streetPlaceholder')}
              onChange={(e) => updateShipmentAddressParams(['street_square'], [e.target.value])}
            />
          </div>

          <div className="col-12 col-md-6">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.number')}<sup>*</sup></p>
            <input
              type="text"
              disabled={!canUpdate}
              className={`form-control mb-2 ${(formSubmitted && shipmentAddress.number?.trim()?.length < 1) && 'border-aiG-red-imp'} address-input-form`}
              value={shipmentAddress.number || ''}
              name={resource ? resource + '[number]' : 'number'}
              id={resource ? resource.replaceAll('[', '_').replaceAll(']', '_') + 'number' : 'number'}
              placeholder={I18n.t('js.newUserAddressForm.numberPlaceholder')}
              onChange={(e) => updateShipmentAddressParams(['number'], [e.target.value])}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-6">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.indoor')}</p>
            <input
              type="text"
              disabled={!canUpdate}
              className="form-control mb-2 address-input-form"
              value={shipmentAddress.indoor ? shipmentAddress.indoor : ''}
              name={resource ? resource + '[indoor]' : 'indoor'}
              id={resource ? resource.replaceAll('[', '_').replaceAll(']', '_') + 'indoor' : 'indoor'}
              placeholder={I18n.t('js.newUserAddressForm.indoorPlaceholder')}
              onChange={(e) => updateShipmentAddressParams(['indoor'], [e.target.value])}
            />
          </div>

          <div className="col-12 col-md-6">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.phoneNumber')}<sup>*</sup></p>
            <input
              type="number"
              disabled={!canUpdate}
              className={`form-control mb-2 ${(formSubmitted && addressType === 'user' && (!shipmentAddress.phone_number || shipmentAddress.phone_number.replaceAll(' ', '').trim()?.length < 9)) && 'border-aiG-red-imp'} hide-arrows-number address-input-form`}
              value={shipmentAddress.phone_number ? shipmentAddress.phone_number : ''}
              name={resource ? resource + '[phone_number]' : 'phone_number'}
              id={resource ? resource.replaceAll('[', '_').replaceAll(']', '_') + 'phone_number' : 'phone_number'}
              placeholder={I18n.t('js.newUserAddressForm.phoneNumberPlaceholder')}
              onChange={(e) => updateShipmentAddressParams(['phone_number'], [e.target.value])}
            />
          </div>

          {
            !hideEmail &&
              <div className="col-12 col-md-6">
                <p className="mb-0">{I18n.t('js.newUserAddressForm.email')}</p>
                <input
                  type="text"
                  disabled={!canUpdate}
                  className={`form-control mb-2 ${(formSubmitted && addressType === 'user' && (!shipmentAddress.email || !regex.test(shipmentAddress.email.trim()))) && 'border-aiG-red-imp'} address-input-form`}
                  value={shipmentAddress.email ? shipmentAddress.email : ''}
                  name={resource ? resource + '[email]' : 'email'}
                  id={resource ? resource.replaceAll('[', '_').replaceAll(']', '_') + 'email' : 'email'}
                  placeholder={I18n.t('js.newUserAddressForm.emailPlaceholder')}
                  onChange={(e) => updateShipmentAddressParams(['email'], [e.target.value])}
                />
              </div>
          }

          <div className="col-12 py-4 d-flex">
            <input
              type="checkbox"
              className="cursor-pointer residenceCheckbox address-input-form"
              value={shipmentAddress.residence === true || shipmentAddress.residence?.toString() === "1" ? 1 : 0}
              name={resource ? resource + '[residence]' : 'residence'}
              id={resource ? resource.replaceAll('[', '_').replaceAll(']', '_') + 'residence' : 'residence'}
              checked={shipmentAddress.residence === true || shipmentAddress.residence?.toString() === "1"}
              onChange={(e) => updateShipmentAddressParams(['residence'], [shipmentAddress.residence === true || shipmentAddress.residence?.toString() === "1" ? false : true])}
            />
            &nbsp;
            <label className="ml-1 mb-0 cursor-pointer font-weight--normal" htmlFor="residenceCheckbox">
              {I18n.t('js.newUserAddressForm.residence')}<br/>
              <small>{I18n.t('js.newUserAddressForm.residenceExplanation')}</small>
            </label>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AddressForm;